<script>
import BaseLayout from "./BaseLayout";
import WorkflowLayout from "./WorkflowLayout";

export default {
    name: "layout",
    props: {
        name: {
            type: String
        }
    },
    components: {
        BaseLayout,
        WorkflowLayout
    },
    created() {
        this.$parent.$emit("update:layout", this.name);
    },
    render(h) {
        const children = Object.keys(this.$scopedSlots).map(slot => {
            return h("template", { slot }, this.$scopedSlots[slot]);
        });
        return h(
            this.name,
            {
                scopedSlots: this.$scopedSlots
            },
            children
        );
    }
};
</script>
